import HexModal from "../../../../../../../../components/HexModal";
import { getLabel } from "../../../../../../../../hooks/use-labels";

const CancelOrderModal = ({
  count,
  loading,
  notification,
  onConfirm,
  onClose,
}) => {
  const multiple = count > 1;

  return (
    <HexModal open={true} onClose={onClose} modalClass="ord-modal">
      <div className="ord-modal-body">
        <span className="ord-modal-icon" aria-hidden="true">
          <img src="/assets/icons/warning-icon.svg" alt="" />
        </span>

        <h2 className="ord-modal-title">{getLabel("cancelOrderLabel")}?</h2>

        <p className="ord-modal-text">
          {multiple
            ? `All ${count} supplier orders will be cancelled.`
            : getLabel("cancelOrderConfirmation")}
        </p>

        {multiple && (
          <p className="ord-modal-hint">
            This purchase is split across {count} suppliers. Each one is
            cancelled separately, so some may fail.
          </p>
        )}

        {notification && <p className="ord-modal-error">{notification}</p>}

        <div className="ord-modal-actions">
          <button
            type="button"
            className="ord-btn ord-btn-outline"
            disabled={loading}
            onClick={onClose}
          >
            {getLabel("noLabel")}
          </button>

          <button
            type="button"
            className="ord-btn ord-btn-danger"
            disabled={loading}
            onClick={onConfirm}
          >
            {loading ? "Cancelling…" : getLabel("yesLabel")}
          </button>
        </div>
      </div>
    </HexModal>
  );
};

export default CancelOrderModal;
